module.exports = __webpack_public_path__ + "img/checkinapp-background.32b834ef.svg";